import axios from 'axios'
import UploadService from './UploadService'
import { localStorage } from '@/utils/basicUtil'

export const INVOICE_APPLY_IMPORT_FUNCTION_POINT = 'agentImportSettlement'
export const INVOICE_APPLY_IMPORT_BUSINESS_TYPE = 'AGENT_IMPORT_SETTLEMENT'
export const INVOICE_APPLY_IMPORT_SOURCE = '14'

export function buildInvoiceBatchImportPayload (template, batchImport) {
  const templateId = template && template.id
  if (templateId === undefined || templateId === null || String(templateId).trim() === '') {
    throw new Error('请选择导入模板')
  }

  const templateType = Number(template.templateType)
  if (templateType !== 0 && templateType !== 1) {
    throw new Error('导入模板类型无效')
  }

  return {
    functionPoint: INVOICE_APPLY_IMPORT_FUNCTION_POINT,
    fileName: batchImport.fileName,
    originFileName: batchImport.originalFileName,
    fileDirectory: batchImport.fileDirectory,
    extraParams: {
      batchImportSource: INVOICE_APPLY_IMPORT_SOURCE,
      customTempId: String(templateId),
      isDef: templateType === 1 ? '1' : '0'
    }
  }
}

export async function uploadInvoiceBatchFile (file) {
  const result = await UploadService(file, INVOICE_APPLY_IMPORT_FUNCTION_POINT, false, false, null, {
    signatureFunctionPoint: INVOICE_APPLY_IMPORT_FUNCTION_POINT,
    autoProcess: false
  })
  if (!result || result.code !== '200') {
    throw new Error((result && result.message) || 'Excel上传失败')
  }
  if (!result.fileName || !result.originFileName || !result.fileDirectory) {
    throw new Error('文件上传结果不完整，请重新上传')
  }
  return result
}

export async function downloadInvoiceImportTemplate (template) {
  if (!template || !template.id) {
    throw new Error('请选择导入模板')
  }
  const response = await axios.post('/api/v2/agent/template/import/download', {
    ids: [template.id],
    businessType: template.businessType || INVOICE_APPLY_IMPORT_BUSINESS_TYPE
  }, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Access-Token': localStorage.get('X-Access-Token') || '',
      'X-C-Token': localStorage.get('X-C-Token') || '',
      'PLATFORM-SOURCE': 'MOBILE'
    }
  })
  const blob = response.data
  const contentType = (response.headers && response.headers['content-type']) || ''
  if (contentType.indexOf('application/json') > -1) {
    const errorMessage = await readBlobErrorMessage(blob)
    throw new Error(errorMessage || '模板下载失败')
  }
  if (!blob || !blob.size) {
    throw new Error('模板下载失败')
  }
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${template.templateName || '开票申请导入模板'}.xlsx`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

function readBlobJson (blob) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      try {
        const result = JSON.parse(reader.result || '{}')
        resolve(result)
      } catch (error) {
        resolve(null)
      }
    }
    reader.onerror = () => resolve(null)
    reader.readAsText(blob)
  })
}

async function readBlobErrorMessage (blob) {
  const result = await readBlobJson(blob)
  return (result && result.message) || ''
}

function getOssFileName (ossKey) {
  const fileName = String(ossKey || '').split('/').pop()
  if (!fileName) return '批量导入错误明细.txt'
  try {
    return decodeURIComponent(fileName)
  } catch (error) {
    return fileName
  }
}

function saveBlob (blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

function formatImportErrorBlob (blob, result) {
  if (!Array.isArray(result)) return blob
  const errorList = result
    .map(item => String(item || '').trim())
    .filter(Boolean)
  if (!errorList.length) return blob
  return new Blob([errorList.join('\r\n\r\n')], { type: 'text/plain;charset=UTF-8' })
}

export async function downloadImportErrorFile (ossKey) {
  if (!ossKey) {
    throw new Error('错误明细文件不存在')
  }

  let previewResponse
  try {
    previewResponse = await axios.get('/api/v2/agent/purchaser/file/view/tmp', {
      params: { ossKey }
    })
  } catch (error) {
    throw new Error('错误明细下载失败，请稍后重试')
  }

  const previewResult = previewResponse.data || {}
  if (String(previewResult.code) !== '200' || !previewResult.data) {
    const errorMessage = previewResult.message || ''
    throw new Error(errorMessage ? `错误明细下载失败：${errorMessage}` : '错误明细下载失败，请稍后重试')
  }

  let response
  try {
    response = await axios.get(previewResult.data, {
      responseType: 'blob'
    })
  } catch (error) {
    const errorMessage = error.response && error.response.data
      ? await readBlobErrorMessage(error.response.data)
      : ''
    throw new Error(errorMessage ? `错误明细下载失败：${errorMessage}` : '错误明细下载失败，请稍后重试')
  }

  const blob = response.data
  const contentType = (response.headers && response.headers['content-type']) || ''
  if (!blob || !blob.size) {
    throw new Error('错误明细文件为空，请稍后重试')
  }
  const responseBody = await readBlobJson(blob)
  if (responseBody && !Array.isArray(responseBody) && (responseBody.code || responseBody.message)) {
    const errorMessage = responseBody.message || ''
    throw new Error(errorMessage ? `错误明细下载失败：${errorMessage}` : '错误明细下载失败，请稍后重试')
  }
  if (contentType.indexOf('application/json') > -1 && !Array.isArray(responseBody)) {
    throw new Error('错误明细下载失败，请稍后重试')
  }
  saveBlob(formatImportErrorBlob(blob, responseBody), getOssFileName(ossKey))
}
